export enum EditMode {
  Search = 'search',
  Edit = 'edit',
  Add = 'add',
}
